<div class="top">
  <div class="top-word">
    <!-- 房源审核失败，请前往爱彼迎修改房源信息后重新提交审核 -->
    {{ "house.check_airbnb_house_failed" | translate }}
  </div>
</div>
<div class="container">
  <div class="info">
    <div class="left">
      <img [src]="detail?.url" />
    </div>
    <div class="right">
      <p class="title">{{ detail?.title || "无" }}</p>
      <div class="third-party">{{ "word.channel_0" | translate }}-{{ detail?.account_id }}</div>
    </div>
  </div>
  <div class="fail-reason">
    <p class="title">
      <!-- 失败原因: -->
      {{ "word.fail_reason" | translate }}
    </p>
    <div class="text" *ngFor="let item of detail?.fail_reason">
      <p>· {{ item?.reason }}</p>
      <div class="picture" *ngIf="item?.urls">
        <div
          *ngFor="let picture of item.urls; index as i"
          [ngClass]="{ 'normal-img': i % 4 !== 3 }"
          style="padding-top: 15px"
        >
          <img [src]="picture" />
        </div>
      </div>
    </div>
    <div class="check-rules" (click)="checkRules()">
      <!-- 查看具体规则 -->
      {{ "channel.airbnb_check_rules" | translate }}
    </div>
  </div>
</div>
<div class="footer">
  <div class="button">
    <button nz-button nzType="primary" nzSize="large" (click)="retry()">
      <!-- 已修改，重新审核 -->
      {{ "house.airbnb_modified_recheck" | translate }}
    </button>
  </div>
  <div class="button">
    <button nz-button nzType="default" nzSize="large" (click)="toFailHouses()">
      <!-- 审核失败房源 -->
      {{ "house.check_failed_channel_house" | translate }}
    </button>
  </div>
</div>

<ng-template #auditRule>
  <div class="host-airbnb-auth-requirement">
    <div class="paragraph">
      <p>
        {{ "channel.airbnb_auth_advantage" | translate }}
        <!-- 1.爱彼迎官方直连的优势： -->
      </p>
      <ul>
        <li>
          {{ "channel.airbnb_auth_advantage_one" | translate }}
          <!-- 官方接口，订单、聊天、改价秒同步，稳定快速不掉线 -->
        </li>
        <!-- <li>房源质量提升，房源排名提升</li> -->
        <li *ngIf="!isInternational">
          {{ "channel.airbnb_auth_advantage_two" | translate }}
        </li>
      </ul>
    </div>
    <div class="paragraph">
      <p>
        {{ "channel.airbnb_auth_disadvantage" | translate }}
        <!-- 2.爱彼迎官方直连的限制： -->
      </p>
      <ul>
        <li>
          {{ "channel.airbnb_auth_disadvantage_one" | translate }}
          <!-- 房源二次审核——按爱彼迎的要求，房源直连后会自动进入机器审核状态，大约1-2分钟即可完成。如果审核未通过，请在房间页面查看未通过的房间信息，按照提示到爱彼迎进行修改，修改之后点击“再次审核”。 -->
        </li>
        <li>
          {{ "channel.airbnb_auth_disadvantage_two" | translate }}
          <!-- 直连后，您需要通过百居易修改房价和房态，为防止改价混乱，爱彼迎后台的修改功能会被官方禁用。百居易提供完善的房价和房态修改功能。 -->
        </li>
        <li>
          {{ "channel.airbnb_auth_disadvantage_three" | translate }}
          <!-- 直连后，将自动开启闪订。闪订有助于提高订单数量，百居易自动关房，不用担心撞单。 -->
        </li>
        <li>
          {{ "channel.airbnb_auth_disadvantage_four" | translate }}
          <!-- 直连后，部分房源的设置需要在百居易中完成，请参考渠道直连-渠道房源-爱彼迎-设置。 -->
        </li>
      </ul>
    </div>
    <div class="paragraph">
      <p>
        {{ "channel.airbnb_auth_check" | translate }}
        <!-- 3.爱彼迎直连房源审核标准： -->
      </p>
      <section>
        <p>
          {{ "channel.airbnb_auth_check_photo" | translate }}
          <!-- 1）照片 -->
        </p>
        <ul>
          <li>
            {{ "channel.airbnb_auth_check_photo_one" | translate }}
            <!-- 7张照片以上，至少两张卧室照片 -->
          </li>
          <li>
            {{ "channel.airbnb_auth_check_photo_two" | translate }}
            <!-- 照片清晰，无明显锯齿或马赛克，分辨率不低于800*500，无水印 -->
          </li>
          <li>
            {{ "channel.airbnb_auth_check_photo_three" | translate }}
            <!-- 包括全景，近景和细节图片，照片水平摆放， 无旋转倒置 -->
          </li>
          <li>
            {{ "channel.airbnb_auth_check_photo_four" | translate }}
            <!-- 卧室&床的数量设置与照片展示一致 -->
          </li>
          <li>
            {{ "channel.airbnb_auth_check_photo_five" | translate }}
            <!-- 全面展现房源里的设施细节 -->
          </li>
          <li>
            {{ "channel.airbnb_auth_check_photo_six" | translate }}
            <!-- 首图为有特色的高清照片，一定不要放卫生间、无意义外景等照片 -->
          </li>
          <li>
            {{ "channel.airbnb_auth_check_photo_seven" | translate }}
            <!-- 请勿在一套房源中上传其他房源的照片 -->
          </li>
        </ul>
      </section>
      <section>
        <p>
          {{ "channel.airbnb_auth_check_title" | translate }}
          <!-- 2）房源标题 -->
        </p>
        <ul>
          <li>
            {{ "channel.airbnb_auth_check_title_one" | translate }}
            <!-- 标题至少20个字，独特的有描述性的房源标题，建议包括地理位置，房子风格或者特色，以及其他必要信息 -->
          </li>
        </ul>
      </section>
      <section>
        <p>
          {{ "channel.airbnb_auth_check_desc" | translate }}
          <!-- 3）房源描述 -->
        </p>
        <ul>
          <li>
            {{ "channel.airbnb_auth_check_desc_one" | translate }}
            <!-- 至少80个字，灵活运用格式和段落，避免大篇幅段落 -->
          </li>
          <li>
            {{ "channel.airbnb_auth_check_desc_two" | translate }}
            <!-- 独特详细的描述内容，展现房源亲和性和主人特质，为目标房客定制的内容描述（有针对性） -->
          </li>
        </ul>
      </section>
      <section>
        <p>
          {{ "channel.airbnb_auth_check_room" | translate }}
          <!-- 4）卧室&床铺信息 -->
        </p>
        <ul>
          <li>
            {{ "channel.airbnb_auth_check_room_one" | translate }}
            <!-- 准确的床铺和卧室信息描述（照片和描述对应） -->
          </li>
        </ul>
      </section>
      <section>
        <p>
          {{ "channel.airbnb_auth_check_conveniences" | translate }}
          <!-- 5）便利设施 -->
        </p>
        <ul>
          <li>
            {{ "channel.airbnb_auth_check_conveniences_one" | translate }}
            <!-- 至少5项便利设施 & 设施需要在照片中得到体现（大部分） -->
          </li>
        </ul>
      </section>
      <section>
        <p>
          {{ "channel.airbnb_auth_check_account" | translate }}
          <!-- 6）账号信息 -->
        </p>
        <ul>
          <li>
            {{ "channel.airbnb_auth_check_account_one" | translate }}
            <!-- 身份验证；手机号码验证；邮箱账号验证；账户头像准确（本人） -->
          </li>
        </ul>
      </section>
    </div>
    <div class="explain-footer">
      <button nz-button nzType="primary" (click)="closeModal()">
        {{ "word.got_it" | translate }}
        <!-- 知道了 -->
      </button>
    </div>
  </div>
</ng-template>
